var _rect, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _g5, _path18, _path19, _path20, _path21, _g6, _path22, _path23, _path24, _path25, _g7, _path26, _path27, _path28, _g8, _path29, _path30, _g9, _path31, _path32, _g10, _path33, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 200,
    viewBox: "0 0 219 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2275_3099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 219,
    height: 201
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 219,
    height: 200,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2275_3099)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 199.062H215.24V0.000976562H2.81982V199.062Z",
    fill: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 219,
    height: 201
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.939941 0.000976562H219V200.001H0.939941V0.000976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9849 45.9844C79.7126 44.2219 78.428 42.8864 76.8819 42.8864C76.6256 42.8864 76.3776 42.9268 76.1398 42.9961C75.5908 39.7374 73.1934 37.2839 70.3179 37.2839C67.9953 37.2839 65.9845 38.8867 65.0086 41.2205C64.6621 41.1284 64.3023 41.078 63.9329 41.078C62.3459 41.078 60.9347 41.9778 60.0309 43.3751C59.5733 43.0655 59.046 42.8864 58.4829 42.8864C56.9368 42.8864 55.6522 44.2219 55.3799 45.9844H79.9849Z",
    fill: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.296 60.1208C189.84 57.1742 187.693 54.9414 185.108 54.9414C184.679 54.9414 184.265 55.0095 183.867 55.1249C182.949 49.6768 178.941 45.575 174.135 45.575C170.251 45.575 166.89 48.2543 165.258 52.1568C164.679 52.0023 164.078 51.9185 163.461 51.9185C160.807 51.9185 158.448 53.423 156.937 55.7586C156.171 55.2403 155.29 54.9414 154.349 54.9414C151.764 54.9414 149.617 57.1742 149.161 60.1208H190.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1283 26.6582C55.196 26.3265 55.2382 25.9873 55.2382 25.6386C55.2382 22.4132 52.1971 19.7983 48.4454 19.7983C48.1022 19.7983 47.7685 19.8273 47.4394 19.8689C46.6532 15.2463 42.0239 11.6956 36.4289 11.6956C30.8421 11.6956 26.218 15.2349 25.4216 19.8481C25.1167 19.8178 24.8086 19.7983 24.4948 19.7983C20.0828 19.7983 16.5062 22.8679 16.4934 26.6582H55.1283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.441 22.7952C211.503 22.4938 211.541 22.186 211.541 21.8695C211.541 18.9405 208.779 16.5665 205.373 16.5665C205.062 16.5665 204.758 16.5929 204.459 16.6308C203.746 12.4331 199.542 9.20966 194.462 9.20966C189.389 9.20966 185.191 12.423 184.468 16.6119C184.191 16.5841 183.911 16.5665 183.626 16.5665C179.621 16.5665 176.373 19.3535 176.361 22.7952H211.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.131 18.5035C152.171 18.3074 152.197 18.1075 152.197 17.902C152.197 15.9989 150.402 14.4559 148.188 14.4559C147.986 14.4559 147.788 14.473 147.594 14.4976C147.131 11.7704 144.399 9.67564 141.098 9.67564C137.802 9.67564 135.074 11.7641 134.604 14.485C134.425 14.4673 134.242 14.4559 134.057 14.4559C131.454 14.4559 129.344 16.2669 129.336 18.5035H152.131Z",
    fill: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2798 65.5311C47.3367 65.2537 47.3719 64.9693 47.3719 64.6773C47.3719 61.9766 44.8255 59.7873 41.6842 59.7873C41.3965 59.7873 41.1172 59.8113 40.8418 59.8466C40.1835 55.9756 36.3071 53.0025 31.6222 53.0025C26.9443 53.0025 23.0724 55.9667 22.4057 59.8289C22.1507 59.8037 21.8925 59.7873 21.6298 59.7873C17.9356 59.7873 14.9406 62.3575 14.9297 65.5311H47.2798Z",
    fill: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.765 70.7352H21.1283C18.5167 70.7352 16.3999 72.8236 16.3999 75.4001V185.596H202.493V75.4001C202.493 72.8236 200.376 70.7352 197.765 70.7352Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.785 178.36H25.1094V78.8745H193.785V178.36Z",
    fill: "#8CBDFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 70,
    width: 104,
    height: 116
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.895 70.7347L99.0962 185.596H202.493V75.3996C202.493 72.8231 200.376 70.7347 197.765 70.7347H189.895Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint0_linear_2275_3099)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.89 70.7327L99.0918 185.594H202.489V75.3977C202.489 72.8212 200.372 70.7327 197.761 70.7327H189.89Z",
    fill: "url(#paint1_linear_2275_3099)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 214,
    height: 201
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 0.000976562H215.24V200.94H2.81982V0.000976562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2275_3099)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63696 184.579C4.63696 191.411 10.2512 196.95 17.1769 196.95H199.004C205.929 196.95 211.544 191.411 211.544 184.579H4.63696Z",
    fill: "#8CBDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.666 187.898H88.8957C87.0888 187.898 85.6233 186.452 85.6233 184.669H126.939C126.939 186.452 125.474 187.898 123.666 187.898Z",
    fill: "#0076BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 184,
    width: 62,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63672 184.579H65.4184V196.95H4.63672V184.579Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2275_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.600006
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 184,
    width: 62,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63623 184.578C4.63623 191.41 10.2505 196.949 17.1762 196.949H65.418C54.8152 193.724 45.4301 189.22 37.5674 184.578H4.63623Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint2_linear_2275_3099)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62891 184.582C4.62891 191.414 10.2431 196.953 17.1689 196.953H65.4106C54.8079 193.728 45.4228 189.224 37.56 184.582H4.62891Z",
    fill: "url(#paint3_linear_2275_3099)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 70,
    width: 112,
    height: 116
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4004 70.7354H127.832V185.596H16.4004V70.7354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2275_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.399994
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 70,
    width: 112,
    height: 116
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1288 70.7348C18.5172 70.7348 16.4004 72.8233 16.4004 75.4004V185.596L127.832 70.7348H21.1288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint4_linear_2275_3099)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 70.7425C18.5133 70.7425 16.3965 72.8309 16.3965 75.4081V185.604L127.828 70.7425H21.1249Z",
    fill: "url(#paint5_linear_2275_3099)"
  })))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.815 166.771C176.58 166.771 173.549 167.799 170.918 169.58C165.723 161.55 157.611 156.377 148.489 156.377C146.365 156.377 144.299 156.666 142.308 157.196C139.4 150.245 134.895 144.427 129.373 140.43C129.376 140.293 129.384 140.156 129.384 140.018C129.384 133.259 126.144 127.248 121.116 123.405C121.595 122.025 121.867 120.549 121.867 119.008C121.867 114.731 119.862 110.921 116.732 108.43C117.257 107.268 117.555 105.986 117.555 104.632C117.555 99.475 113.318 95.2943 108.091 95.2943C102.864 95.2943 98.6262 99.475 98.6262 104.632C98.6262 105.986 98.924 107.268 99.4488 108.43C96.3189 110.921 94.3133 114.731 94.3133 119.008C94.3133 120.549 94.5856 122.025 95.0643 123.405C90.0368 127.248 86.797 133.259 86.797 140.018C86.797 141.168 86.8941 142.296 87.0744 143.396C83.1737 147.103 79.9607 151.809 77.7077 157.196C75.7168 156.666 73.6505 156.377 71.5266 156.377C62.4041 156.377 54.2915 161.55 49.0972 169.58C46.4665 167.799 43.4357 166.771 40.2004 166.771C31.3118 166.771 23.9284 174.448 22.3625 184.578H56.2243H163.791H197.653C196.087 174.448 188.703 166.771 179.815 166.771Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 95,
    width: 88,
    height: 90
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3616 95.304H109.54V184.578H22.3616V95.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2275_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 95,
    width: 88,
    height: 90
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0444 184.576C67.4063 179.048 73.2787 175.011 79.7475 173.993C81.089 167.257 88.0761 162.106 95.0044 162.745C92.136 156.064 93.9077 147.708 99.2515 142.721C97.3405 136.498 99.9367 129.195 105.369 125.513C102.335 120.148 104.279 112.596 109.541 109.309C106.759 104.989 107.656 100.133 107.902 95.3024C102.763 95.4027 98.6258 99.5367 98.6258 104.631C98.6258 105.984 98.9243 107.267 99.449 108.428C96.3192 110.92 94.3135 114.73 94.3135 119.007C94.3135 120.548 94.5858 122.023 95.0645 123.404C90.037 127.247 86.7972 133.257 86.7972 140.016C86.7972 141.167 86.8944 142.295 87.0746 143.394C83.1739 147.102 79.961 151.809 77.708 157.195C75.7171 156.665 73.6507 156.376 71.5262 156.376C62.4044 156.376 54.2918 161.549 49.0974 169.579C46.4661 167.798 43.4353 166.77 40.2 166.77C31.3121 166.77 23.9287 174.446 22.3628 184.576H56.2245H64.0444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint6_linear_2275_3099)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.041 184.59C67.4029 179.062 73.2753 175.025 79.7441 174.006C81.0856 167.27 88.0727 162.119 95.001 162.758C92.1326 156.077 93.9043 147.721 99.2481 142.734C97.3371 136.511 99.9333 129.209 105.365 125.527C102.331 120.161 104.276 112.609 109.538 109.323C106.755 105.003 107.653 100.147 107.898 95.3159C102.76 95.4161 98.6224 99.5501 98.6224 104.644C98.6224 105.998 98.9209 107.28 99.4456 108.442C96.3157 110.933 94.3101 114.744 94.3101 119.02C94.3101 120.561 94.5824 122.037 95.0611 123.418C90.0336 127.26 86.7938 133.271 86.7938 140.03C86.7938 141.181 86.891 142.308 87.0712 143.408C83.1705 147.115 79.9575 151.822 77.7046 157.209C75.7136 156.679 73.6473 156.389 71.5228 156.389C62.401 156.389 54.2883 161.562 49.094 169.593C46.4627 167.811 43.4319 166.783 40.1965 166.783C31.3086 166.783 23.9253 174.46 22.3594 184.59H56.2211H64.041Z",
    fill: "url(#paint7_linear_2275_3099)"
  })))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.399 69.7618C138.376 73.624 137.236 77.6666 136.104 81.4872C133.821 89.1857 131.54 96.8836 129.258 104.582C128.897 105.798 128.29 107.236 127.015 107.398C125.246 107.623 124.424 105.293 124.392 103.534C124.339 100.595 124.66 97.6491 125.346 94.7877C125.559 93.8986 125.805 92.9596 125.527 92.0882C125.262 91.2628 124.571 90.6493 123.886 90.1063C121.19 87.9656 118.145 86.2517 114.905 85.0517C115.679 80.3477 116.235 68.2428 120.185 65.0206C122.484 63.146 136.723 67.0845 137.399 69.7618Z",
    fill: "#0076BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 64,
    width: 19,
    height: 27
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.133 64.5322H134.771V90.0808H116.133V64.5322Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2275_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.399994
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 64,
    width: 19,
    height: 27
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.186 65.0203C117.998 66.8042 116.852 71.3108 116.133 75.7771C117.44 79.6198 119.011 84.1176 120.236 87.6008C121.496 88.348 122.707 89.1734 123.853 90.0808L134.771 67.6403C130.38 65.4857 121.913 63.6116 120.186 65.0203Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint8_linear_2275_3099)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.18 65.0293C117.992 66.8132 116.846 71.3198 116.127 75.7861C117.434 79.6288 119.005 84.1266 120.23 87.6098C121.489 88.3571 122.701 89.1825 123.847 90.0898L134.765 67.6493C130.374 65.4947 121.907 63.6207 120.18 65.0293Z",
    fill: "url(#paint9_linear_2275_3099)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6923 70.6266C77.8327 74.5159 79.095 78.5225 80.3426 82.3084C82.8563 89.9364 85.3707 97.5637 87.8845 105.191C88.2814 106.397 88.932 107.815 90.2109 107.94C91.9858 108.114 92.7375 105.76 92.7157 104C92.6799 101.061 92.2696 98.1261 91.4988 95.2867C91.2591 94.4039 90.983 93.4726 91.2361 92.5936C91.4751 91.7606 92.1482 91.1269 92.8148 90.5644C95.4455 88.3448 98.4373 86.5421 101.64 85.2475C100.724 80.5675 99.8019 68.4852 95.7548 65.3803C93.4009 63.5744 79.288 67.931 78.6923 70.6266Z",
    fill: "#0076BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 64,
    width: 20,
    height: 34
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5913 64.956H101.081V97.092H82.5913V64.956Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2275_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.399994
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 64,
    width: 20,
    height: 34
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.081 81.7904C100.246 76.2004 99.014 67.8808 95.755 65.3806C94.995 64.7973 93.0054 64.8597 90.6438 65.298L82.5906 89.1308C83.4528 91.7451 84.3143 94.3588 85.1759 96.9737C87.4276 97.067 89.9893 97.1326 91.9214 97.0639C91.7929 96.4686 91.6587 95.8753 91.4989 95.287C91.2593 94.4048 90.9831 93.4728 91.2362 92.5938C91.4753 91.7609 92.1483 91.1271 92.8149 90.5647C94.7483 88.9334 96.8779 87.5298 99.1418 86.3847C99.7867 84.8738 100.447 83.3151 101.081 81.7904Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint10_linear_2275_3099)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.074 81.7917C100.24 76.2018 99.0074 67.8821 95.7484 65.3819C94.9884 64.7986 92.9988 64.8611 90.6372 65.2993L82.584 89.1321C83.4462 91.7464 84.3077 94.3601 85.1693 96.9751C87.421 97.0684 89.9827 97.134 91.9148 97.0652C91.7863 96.47 91.6521 95.8766 91.4923 95.2883C91.2527 94.4062 90.9765 93.4742 91.2296 92.5952C91.4687 91.7622 92.1417 91.1285 92.8083 90.566C94.7417 88.9348 96.8714 87.5311 99.1352 86.386C99.7801 84.8752 100.44 83.3164 101.074 81.7917Z",
    fill: "url(#paint11_linear_2275_3099)"
  })))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.586 97.4148C128.016 73.1841 126.677 44.5193 115.704 20.4961C114.799 18.5149 113.008 16.9902 110.85 16.5513C110.77 16.5349 110.69 16.5198 110.611 16.5053C107.734 15.9819 104.843 17.3382 103.257 19.7634C88.9449 41.6389 87.4985 74.5985 99.8064 97.6765C105.545 98.3859 111.816 97.0459 117.586 97.4148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 16,
    width: 17,
    height: 82
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.257 19.763C88.945 41.6385 87.4987 74.5987 99.806 97.6767C102.398 97.9971 105.099 97.8993 107.813 97.7297C106.909 89.9687 106.136 79.4452 102.581 65.9985C95.401 38.8401 102.361 24.7476 107.023 16.8019C105.505 17.3372 104.166 18.3732 103.257 19.763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint12_linear_2275_3099)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.255 19.7682C88.9431 41.6438 87.4967 74.604 99.804 97.682C102.396 98.0023 105.097 97.9046 107.811 97.735C106.907 89.974 106.134 79.4505 102.579 66.0037C95.3991 38.8453 102.359 24.7528 107.021 16.8071C105.503 17.3425 104.164 18.3785 103.255 19.7682Z",
    fill: "url(#paint13_linear_2275_3099)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 69,
    width: 12,
    height: 29
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6252 93.157C98.2976 94.7 99.023 96.209 99.806 97.6769C102.496 98.0092 105.303 97.8901 108.12 97.7103V74.4066L105.563 69.3614L97.6252 93.157Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint14_linear_2275_3099)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6152 93.1529C98.2876 94.6959 99.013 96.2048 99.796 97.6728C102.486 98.0051 105.293 97.8859 108.11 97.7062V74.4024L105.553 69.3573L97.6152 93.1529Z",
    fill: "url(#paint15_linear_2275_3099)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 64,
    width: 11,
    height: 34
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.636 64.7973L114.677 97.3584H114.678C115.119 97.3508 115.559 97.3508 115.995 97.3578C116.071 97.359 116.147 97.3597 116.222 97.3609C116.678 97.371 117.134 97.3862 117.586 97.4152C122.025 87.101 124.326 75.9836 124.664 64.762L124.636 64.7973Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2275_3099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20996,
    y: -20414,
    width: 41888,
    height: 41325
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-20995.1 -20413.1H20891.1V20910.9H-20995.1V-20413.1Z",
    fill: "url(#paint16_linear_2275_3099)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.634 64.7943L114.676 97.3554H114.676C115.117 97.3478 115.557 97.3478 115.994 97.3547C116.069 97.356 116.145 97.3566 116.221 97.3579C116.677 97.368 117.133 97.3831 117.585 97.4121C122.024 87.098 124.324 75.9805 124.663 64.759L124.634 64.7943Z",
    fill: "url(#paint17_linear_2275_3099)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2275_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: -6,
    width: 212,
    height: 211
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 -5.63284H213.361V204.696H2.81982V-5.63284Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2275_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.144 104.515L106.797 110.146C106.928 111.271 107.902 112.115 109.05 112.098C110.215 112.081 111.17 111.184 111.246 110.038L113.685 73.0072C113.893 69.8619 111.399 67.1827 108.205 67.1184C104.811 67.0496 102.134 69.9502 102.52 73.2771L103.294 79.9421",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4636 10.8734L70.8201 12.1452L68.4636 13.4165L67.1751 15.7407L65.8859 13.4165L63.53 12.1452L65.8859 10.8734L67.1751 8.54851L68.4636 10.8734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.131 39.89L199.488 41.1612L197.131 42.4324L195.842 44.7573L194.554 42.4324L192.198 41.1612L194.554 39.89L195.842 37.5651L197.131 39.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.535 35.5967L151.479 36.1069L150.535 36.6164L150.017 37.5483L149.501 36.6164L148.556 36.1069L149.501 35.5967L150.017 34.6648L150.535 35.5967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.065 4.70956L173.009 5.21905L172.065 5.72855L171.548 6.66052L171.031 5.72855L170.087 5.21905L171.031 4.70956L171.548 3.77758L172.065 4.70956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7841 39.3906L24.7287 39.9001L23.7841 40.4096L23.267 41.3416L22.7506 40.4096L21.8059 39.9001L22.7506 39.3906L23.267 38.4586L23.7841 39.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.26 52.2024L104.137 45.3344L104.554 45.5425L104.422 45.7715L104.335 45.9588L103.809 46.8537L100.808 52.2024L104.422 58.6126L111.607 58.6126L115.243 52.2024L111.497 45.5425L112.023 45.5425L115.79 52.2024L111.891 59.0704L104.137 59.0704L100.26 52.2024Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.26 38.9032L104.137 32.0352L107.335 32.0352L107.073 32.493L104.422 32.493L100.808 38.9032L104.422 45.3341L107.094 45.3341L107.357 45.792L104.137 45.792L100.26 38.9032ZM111.366 32.0352L111.914 32.0352L115.791 38.9032L112.023 45.5422L111.476 45.5422L115.221 38.9032L111.366 32.0352Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.05 28.544C108.962 28.5231 108.874 28.5231 108.787 28.5231C108.371 28.5231 108.042 28.7104 108.042 29.3347C108.042 29.8967 108.524 30.4586 109.05 30.5626L109.05 28.544ZM109.948 28.1691C110.474 28.4189 111.087 28.9391 111.087 30.0629C111.087 30.9162 110.605 31.3533 109.882 31.3533C108.656 31.3533 107.561 30.4375 107.561 29.1264C107.561 28.3146 108.021 27.9193 108.787 27.9193C109.006 27.9193 109.247 27.9402 109.51 28.0026L109.51 30.6665C109.641 30.6873 109.773 30.7081 109.86 30.7081C110.32 30.7081 110.583 30.4375 110.583 29.8548C110.583 29.2721 110.167 28.8142 109.926 28.7726L109.926 28.1691L109.948 28.1691ZM107.648 33.8715L108.13 33.9756L108.13 33.9547C107.955 33.7882 107.561 33.3512 107.561 32.7268C107.561 32.2482 107.714 31.6862 108.371 31.6862C108.481 31.6862 108.59 31.707 108.721 31.7279L110.999 32.2482L110.999 32.8517L108.94 32.373C108.787 32.3314 108.656 32.3106 108.546 32.3106C108.24 32.3106 108.064 32.4979 108.064 32.935C108.064 33.2888 108.261 33.9547 109.181 34.1629L110.999 34.5791L110.999 35.2035L107.648 34.4334L107.648 33.8715ZM107.165 35.7865L106.531 35.6408L106.531 35.0373L107.165 35.1829L107.165 35.7865ZM110.999 36.0571L110.999 36.6606L107.648 35.8906L107.648 35.2662L110.999 36.0571ZM107.648 41.0725L108.13 41.1765L108.13 41.1557C107.955 40.9893 107.561 40.573 107.561 39.9278C107.561 39.2827 107.933 39.1578 108.108 39.0953C107.802 38.7207 107.582 38.4294 107.561 37.8674C107.561 37.2014 108.021 36.7644 108.678 36.9309L110.999 37.5136L110.999 38.138L108.831 37.6385C108.721 37.6177 108.612 37.5969 108.524 37.5969C108.24 37.5969 108.042 37.7425 108.042 38.138C108.042 38.6583 108.481 39.0953 108.94 39.1994L110.978 39.6781L110.978 40.2816L108.656 39.7405C108.59 39.7197 108.524 39.7197 108.459 39.7197C108.24 39.7197 108.021 39.8238 108.021 40.1776C108.021 40.5314 108.218 41.1765 109.116 41.3847L110.956 41.8009L110.956 42.4253L107.648 41.6344L107.648 41.0725ZM109.488 44.6107C109.532 45.0894 109.707 45.5472 110.211 45.5472C110.474 45.5472 110.627 45.3599 110.627 44.9853C110.627 44.4234 110.298 43.7782 109.838 43.6741L109.291 43.5493C109.357 43.6741 109.466 44.0904 109.488 44.6107ZM108.655 45.651C107.845 45.4636 107.538 44.7769 107.538 43.8819C107.538 43.6113 107.604 42.7373 108.261 42.7373C108.48 42.7373 110.32 43.2159 110.451 43.2159C110.539 43.2159 110.583 43.1743 110.583 43.0494C110.583 42.987 110.561 42.8829 110.561 42.8413L110.999 42.9454C111.021 43.0286 111.065 43.1951 111.065 43.2784C111.065 43.6113 110.977 43.8403 110.692 43.8403C110.649 43.8403 110.605 43.8403 110.561 43.8195C110.802 44.1109 111.109 44.5479 111.109 45.2555C111.109 45.8383 110.802 46.2129 110.364 46.2129C109.641 46.2129 109.181 45.5469 109.115 44.8809C109.093 44.652 109.006 43.9027 108.984 43.7779C108.918 43.4449 108.677 43.3616 108.458 43.3616C108.195 43.3616 108.064 43.5906 108.064 44.09C108.064 44.7769 108.458 44.985 108.699 45.0682L108.699 45.651L108.655 45.651ZM107.648 48.5857L108.13 48.6898L108.13 48.6689C107.955 48.5024 107.561 48.0654 107.561 47.441C107.561 46.9415 107.714 46.4004 108.371 46.4004C108.481 46.4004 108.59 46.4212 108.721 46.442L110.999 46.9832L110.999 47.5867L108.94 47.108C108.787 47.0664 108.656 47.0456 108.546 47.0456C108.24 47.0456 108.064 47.2329 108.064 47.6699C108.064 48.0238 108.261 48.6898 109.181 48.8979L110.999 49.3141L110.999 49.9385L107.648 49.1684L107.648 48.5857Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.677 54.4708L111.103 56.1774L111.103 51.2033L109.898 50.9327L109.898 54.6581L107.752 54.1586L107.752 50.8078L106.656 50.5581L106.656 53.9088L104.751 53.451L104.751 49.7464L103.677 49.4967L103.677 54.4708Z",
    fill: "#0076BE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2275_3099",
    x1: 145.095,
    y1: 130.283,
    x2: 266.526,
    y2: 125.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2275_3099",
    x1: 145.096,
    y1: 130.286,
    x2: 266.527,
    y2: 125.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2275_3099",
    x1: 5.7292,
    y1: 187.327,
    x2: 67.6808,
    y2: 197.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.890013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2275_3099",
    x1: 5.72884,
    y1: 187.331,
    x2: 67.6804,
    y2: 197.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1762FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B61FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2275_3099",
    x1: 16.4,
    y1: 128.17,
    x2: 127.832,
    y2: 128.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.890013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "white",
    stopOpacity: 0.0292668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2275_3099",
    x1: 16.3965,
    y1: 128.173,
    x2: 127.828,
    y2: 128.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1762FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "#5558D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2275_3099",
    x1: 62.3689,
    y1: 138.484,
    x2: 102.658,
    y2: 160.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.890013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2275_3099",
    x1: 62.3705,
    y1: 138.492,
    x2: 102.659,
    y2: 160.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1762FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B61FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2275_3099",
    x1: 135.027,
    y1: 69.6966,
    x2: 103.714,
    y2: 89.1072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.890013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "white",
    stopOpacity: 0.0292668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2275_3099",
    x1: 135.027,
    y1: 69.7008,
    x2: 103.714,
    y2: 89.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#154562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "#5558D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2275_3099",
    x1: 97.8798,
    y1: 77.0346,
    x2: 72.0998,
    y2: 93.6633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.890013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "white",
    stopOpacity: 0.0292668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2275_3099",
    x1: 97.8776,
    y1: 77.0377,
    x2: 72.0976,
    y2: 93.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970723,
    stopColor: "#5558D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2275_3099",
    x1: 64.6724,
    y1: 66.0037,
    x2: 121.006,
    y2: 54.1758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2275_3099",
    x1: 64.6723,
    y1: 66.0062,
    x2: 121.006,
    y2: 54.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2275_3099",
    x1: 114.001,
    y1: 75.904,
    x2: 92.3193,
    y2: 99.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2275_3099",
    x1: 113.998,
    y1: 75.9081,
    x2: 92.3161,
    y2: 99.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2275_3099",
    x1: 131.246,
    y1: 81.9047,
    x2: 108.056,
    y2: 80.1586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2275_3099",
    x1: 131.243,
    y1: 81.9054,
    x2: 108.053,
    y2: 80.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.6e4a6454cb6a41d4cde026b20709d502.svg";
export { ForwardRef as ReactComponent };